import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './../styles/sidebar.css';

const sidebarIcons = {
  users: '👥',
  addresses: '📍',
  alerts: '🔔',
  articles: '📰',
  authors: '✍️',
  companies: '🏢',
  company_addresses: '🏠',
  configurations: '⚙️',
  images: '🖼️',
  keywords: '🔑',
  matches: '🎯',
  pdffiles: '📄',
  permissions: '🔒',
  role_permissions: '🛡️',
  roles: '👔',
  sources: '📡',
  user_addresses: '📬',
  user_alert: '📢',
  user_roles: '🎭',
};

const Sidebar = ({ endpoints, activeEndpoint, onSelect }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <h3>{isCollapsed ? '' : 'Menu'}</h3>
        <button className="collapse-btn" onClick={toggleSidebar} title={isCollapsed ? 'Expand' : 'Collapse'}>
          {isCollapsed ? '▸' : '◂'}
        </button>
      </div>
      <ul className="sidebar-menu">
        {endpoints.map((endpoint) => (
          <li
            key={endpoint.id}
            className={`sidebar-item ${
              activeEndpoint === endpoint.id ? 'active' : ''
            }`}
            onClick={() => onSelect(endpoint.id)}
          >
            <NavLink
              to={`/dashboard?tab=${endpoint.id}`}
              className="sidebar-link"
            >
              {isCollapsed ? (
                <span title={endpoint.name}>
                  {sidebarIcons[endpoint.id] || endpoint.name.charAt(0)}
                </span>
              ) : (
                <>
                  <span style={{ marginRight: '8px', fontSize: '0.9em' }}>
                    {sidebarIcons[endpoint.id] || '•'}
                  </span>
                  {endpoint.name}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
